import * as React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useQueryClient } from 'react-query';
import { EmptyState, Helmet, CenteredGrid, Pagination } from '../../../shared';
import tags from '../../../../apis/seoTags';
import Loader from '../../../global/Loader';
import { usePaginatedQuery, usePerPageOptions } from '../../../../hooks';
import RequestsList from './RequestedList';
import DashBoard from '../../../../apis/DashBoard';
import apiPaths from '../../../../helpers/apiPaths';
import { status200 } from '../../../../apis/swagup/status.utils';
import { CardsContainer } from '../../../shared/containers/Cards';

const fetchOpportunities = query =>
  DashBoard.get(`${apiPaths.opportunities}?proofs_only=1&ordering=-modified_on&${query}`, status200).then(
    response => response.data
  );

const useStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    marginTop: 36,
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '32px',
    width: '100%',
    [theme.breakpoints.only('xl')]: {
      columnGap: '15px',
      gridTemplateColumns: 'repeat(5, 1fr)'
    },
    [theme.breakpoints.only('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)'
    },
    [theme.breakpoints.only('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)'
    },
    [theme.breakpoints.only('xs')]: {
      gridTemplateColumns: 'repeat(1, 1fr)'
    }
  },
  paginationContainer: {
    paddingTop: 30,
    paddingBottom: 60
  }
}));

const RequestedOrders = () => {
  const classes = useStyles();

  const perPageOptions = usePerPageOptions();
  const { query, pagination } = usePaginatedQuery({
    queryKey: [apiPaths.opportunities],
    queryFn: (limit, offset) => {
      const apiQuery = new URLSearchParams();
      apiQuery.set('limit', limit);
      if (offset > 0) apiQuery.set('offset', offset);
      return fetchOpportunities(apiQuery.toString());
    },
    perPageOptions
  });

  const queryClient = useQueryClient();
  React.useEffect(() => {
    queryClient.invalidateQueries([apiPaths.opportunities]);
  }, [queryClient]);

  if (query.data === undefined) return <Loader absolute />;

  return (
    <>
      <Helmet tags={tags.ordersRequested} />
      {pagination.count === 0 ? (
        <EmptyState
          title="No Proofs"
          image={{
            path: '/images/dashboard/empty-proofs.png',
            alt: 'No proofs',
            text: 'You’ve submitted no order requests yet.'
          }}
          button={{
            link: '/product-onboarding',
            text: 'Start new order'
          }}
        />
      ) : (
        <CenteredGrid>
          <CardsContainer>
            <RequestsList opportunities={query.data.results} />
          </CardsContainer>
          <Grid container item xs={12} justifyContent="center" className={classes.paginationContainer}>
            <Pagination {...pagination} endText="requested" />
          </Grid>
        </CenteredGrid>
      )}
    </>
  );
};

export default RequestedOrders;
